export default "/8522fe2631ecefb1e3967be9883671f05392a386/b94cdee409f55382a26c8aa8c74f2625.png";